import React from "react";
import { graphql, Link as GatsbyLink } from "gatsby";
import { HelmetDatoCms } from "gatsby-source-datocms";
import { Box, Container, Grid, Heading, Link } from "theme-ui";
import Layout from "../components/layout";
import ArticleItem from "../components/articleItem";

const Blog = ({ data: { blog, articles, categories }, pageContext }) => {
  const publishedArticles = articles.nodes.filter(
    (article) => article.slug !== null
  );
  return (
    <Layout>
      <HelmetDatoCms seo={blog.seoMetaTags} />
      <Box py={6}>
        <Container>
          <Heading variant="display" as="h1">
            {blog.title}
          </Heading>
        </Container>
        <Container>
          <Grid columns={[1, 1, 1, 1, "3fr 1fr"]} gap={6}>
            <div>
              {publishedArticles.map((article) => (
                <ArticleItem
                  title={article.title}
                  image={article.image}
                  slug={article.slug}
                  publishedAt={article.meta.firstPublishedAt}
                  key={article.originalId}
                />
              ))}
            </div>
            <div>
              <Heading variant="headingSmall" sx={{ mb: 3 }}>
                Categorie
              </Heading>
              {categories.nodes.map((category) => (
                <Link
                  to={`${pageContext.categoryPath}/${category.slug}`}
                  as={GatsbyLink}
                  key={category.originalId}
                >
                  {category.name}
                </Link>
              ))}
            </div>
          </Grid>
        </Container>
      </Box>
    </Layout>
  );
};

export default Blog;

export const query = graphql`
  query BlogQuery($originalId: String!, $locale: String!) {
    blog: datoCmsBlog(originalId: { eq: $originalId }) {
      title
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
    }
    categories: allDatoCmsArticleCategory(filter: { locale: { eq: $locale } }) {
      nodes {
        name
        slug
        originalId
      }
    }
    articles: allDatoCmsArticle(
      filter: { locale: { eq: $locale } }
      sort: { fields: meta___firstPublishedAt, order: DESC }
    ) {
      nodes {
        title
        body
        slug
        originalId
        image {
          fluid(maxWidth: 1440) {
            ...GatsbyDatoCmsFluid
          }
        }
        meta {
          firstPublishedAt(locale: $locale, formatString: "dddd D/M/Y")
        }
      }
    }
  }
`;
